import jsonp from 'jsonp';

const initUrl = 'https://apis.map.qq.com';
const key = 'R2GBZ-NDAWR-3WNWB-WPLRM-ZNWH5-FQF4D';

// 地图地址转坐标
export function addressToLatLng(address) {
  return new Promise((resolve, reject) => {
    jsonp(`${initUrl}/ws/geocoder/v1/?address=${address}&key=${key}&output=jsonp`, (_, res) => {
      if (res.status === 0) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}

// 获取腾讯地图的省市区三级行政规划
export function getDistrict() {
  return new Promise((resolve, reject) => {
    jsonp(`${initUrl}/ws/district/v1/list?key=${key}&output=jsonp`, (_, res) => {
      if (res.status === 0) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}

// 获取腾讯地图的下级行政区划
export function getchildren(id = '') {
  return new Promise((resolve, reject) => {
    jsonp(`${initUrl}/ws/district/v1/getchildren?${id ? `id=${id}` : ''}&key=${key}&output=jsonp`, (_, res) => {
      if (res.status === 0) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}
